import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const FullscreenIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5d0'}</MuiIcon>
    );
}